import { ResItem } from "components/common/Filters/Filters";
import NavTabContent from "components/common/NavTabContent";
import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import { useAppSelector } from "redux/hooks";

const CorpWizard = () => {
  const [checkedValue, setCheckedValue] = useState<any>([]);
  const [accordionState, setAccordionState] = useState<string>("");
  const [selectedAccordian, setSelectedAccordian] = useState<string>("");
  const [selectedFilterCategory, setSelectedFilterCategory] = useState<string>("");

  const filterCategories: ResItem[] = useAppSelector((state) => state.filters.filterCategories);
  const isOpenCorpWizard = useAppSelector((state) => state.filters.isOpenCorpWizard);

  const toggleAccordion = (panel: string) => {
    setAccordionState(panel);
  };

  useEffect(() => {
    const firstSelected = filterCategories?.find((obj) => obj.wizardDisplay === "Y");
    if (firstSelected) setSelectedFilterCategory(firstSelected.key);
  }, [filterCategories]);

  const updateFilterOptions = (key: string, id: number, addValue: string, booleanValue: boolean, name: string) => {
    const myFilters = cloneDeep(checkedValue);
    let filterIndex = myFilters?.findIndex((filter: any) => filter?.id === id);
    if (filterIndex < 0) {
      const obj = {
        id,
        name,
        key,
        options: [addValue]
      };
      myFilters.push(obj);
    } else {
      if (booleanValue) {
        const selectedVal = cloneDeep(myFilters[filterIndex]);
        selectedVal.options.push(addValue);
        myFilters.splice(filterIndex, 1);
        myFilters.splice(filterIndex, 0, selectedVal);
      } else {
        const selectedVal = cloneDeep(myFilters[filterIndex]);
        const optionTORemove = selectedVal.options.findIndex((option: any) => option === addValue);
        myFilters[filterIndex]?.options?.splice(optionTORemove, 1);
        if (!myFilters[filterIndex]?.options.length) {
          myFilters.splice(filterIndex, 1);
        }
      }
    }
    setCheckedValue(myFilters);
  };

  return (
    <div>
      <NavTabContent
        filters={filterCategories}
        handleSetCategory={(val: string) => setSelectedFilterCategory(val)}
        selectedFilterCategory={selectedFilterCategory}
        updateFilterOptions={updateFilterOptions}
        checkedValue={checkedValue}
        toggleAccordion={toggleAccordion}
        accordionState={accordionState}
        setSelectedAccordian={(val: string) => {
          setSelectedAccordian(val);
        }}
        selectedAccordian={selectedAccordian}
        isOpenCorpWizard={isOpenCorpWizard}
      />
    </div>
  );
};

export default CorpWizard;
